import React from 'react'

import { Col, Row } from '_zari/core'

import * as FormGroups from './formGroups'

const IngresoSection = ({
  errors,
  touched,
  isSubmitting,
  handleChange,
  values,
  setFieldValue,
  vOrigen
}) => {
  return (
    <>
      <Row>
        <Col md={6}>
          <FormGroups.TipoDocumentoFormGroup
            fIsSubmitting={isSubmitting}
            handleChange={handleChange}
            iError={errors.tipoDocumento}
            iTouched={touched.tipoDocumento}
            iValue={values.tipoDocumento}
            setFieldValue={setFieldValue}
            iOrigen={vOrigen}
          />
        </Col>
        <Col md={2}>
          <FormGroups.SerieDocumentoFormGroup
            setFieldValue={setFieldValue}
            fIsSubmitting={isSubmitting}
            iError={errors.serieDocumento}
            iTouched={touched.serieDocumento}
          />
        </Col>
        <Col md={4}>
          <FormGroups.NumeroDocumentoFormGroup
            fIsSubmitting={isSubmitting}
            iError={errors.numeroDocumento}
            iTouched={touched.numeroDocumento}
          />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroups.FechaDocumentoFormGroup
            fIsSubmitting={isSubmitting}
            iError={errors.fechaDocumento}
            iTouched={touched.fechaDocumento}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
          />
        </Col>
        <Col md={6}>
          <FormGroups.FechaVencimientoFormGroup
            fIsSubmitting={isSubmitting}
            iError={errors.fechaVencimiento}
            iTouched={touched.fechaVencimiento}
          />
        </Col>
      </Row>
    </>
  )
}

export default React.memo(IngresoSection)
